
import Vue from 'vue';
import { Avatar } from '@descomplica/vue-components';
import { UserModel } from '@descomplica/dex-models';

export default Vue.extend({
  components: {
    Avatar,
  },
  props: {
    user: {
      type: Object as Vue.PropType<UserModel>,
      required: true,
    },
  },
  computed: {
    label(): string | null | undefined {
      return this.user.isAdmin() ? `Prof. ${this.user.name}` : this.user.name;
    },
  },
});
